// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_aDC","cls2":"CreateSocialItemModal-cls2_Fxr CreateSocialItemModal-cls1_aDC"};